import * as React from 'react';

import { observer } from 'mobx-react';

import { ISocialProvider } from '~domain/entities/Config';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { classes } from '~utils/Classes';
import { SocialButtonWrapperViewController } from '~views/components/SocialButtonWrapperViewController';

import { SocialButton } from '../social-sign-in/SocialButton';

export const TEST_ID_SOCIAL_BUTTON_WRAPPER = 'iam-social-button-wrapper';
const socialButtonsClasses = classes('iam-social-buttons');

export const SocialButtonWrapper = observer(() => {
    const viewController: SocialButtonWrapperViewController = diContainer.get(
        serviceNames.socialButtonViewController
    );

    const {
        data: { isFormLoading, providers, buttonStyle },
        onLoginClicked
    } = viewController;

    return (
        <>
            {providers?.length && (
                <div className={socialButtonsClasses} data-test-id={TEST_ID_SOCIAL_BUTTON_WRAPPER}>
                    {providers.map(
                        ({
                            providerName,
                            buttonLabelKey,
                            oauthConfig: { clientId }
                        }: ISocialProvider) => {
                            return (
                                <>
                                    {!!clientId && (
                                        <SocialButton
                                            provider={providerName}
                                            onClick={onLoginClicked.bind(null, providerName)}
                                            isFormLoading={isFormLoading}
                                            labelKey={buttonLabelKey || ''}
                                            buttonStyle={buttonStyle}
                                        />
                                    )}
                                </>
                            );
                        }
                    )}
                </div>
            )}
        </>
    );
});
